export default __webpack_public_path__ + "static/media/gallery-wip-grenade cap_05.2d69120a.jpg";